import Vue from 'vue'
import VueI18n from 'vue-i18n'
const LANG_KEY = 'language'
Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {

    console.log('keeysss', key);
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  console.log(messages, 'messs');
  return messages
}

export default new VueI18n({
  locale:  window.localStorage.getItem(LANG_KEY) || window.navigator.language || process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
